<template>
	<div id="app">
		<div class="container is-fluid">
			<div class="card">
				<router-view name="site"></router-view>
			</div>
		</div>
		<div class="container is-fluid">
			
				
				<router-view name="main"></router-view>
			
		</div>
		<router-view name="login"></router-view>
	</div>
</template>



<script>
export default {
	name: "app"
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:400");
@import url("https://fonts.googleapis.com/css?family=Nunito+Sans");
@import url("https://fonts.googleapis.com/css?family=Roboto:400");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300");
$family-sans-serif: "Roboto", serif;

// Set your colors 904C6B FF7F50
$primary: #cb5031;
$info: #ff7f50;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$footer-background-color: #253c7e;
$beige-lighter: #eff0eb;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
	"white": (
		$white,
		$black
	),
	"black": (
		$black,
		$white
	),
	"light": (
		$light,
		$light-invert
	),
	"dark": (
		$dark,
		$dark-invert
	),
	"primary": (
		$primary,
		$primary-invert
	),
	"info": (
		$info,
		$info-invert
	),
	"success": (
		$success,
		$success-invert
	),
	"warning": (
		$warning,
		$warning-invert
	),
	"danger": (
		$danger,
		$danger-invert
	),
	"twitter": (
		$twitter,
		$twitter-invert
	)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;
$card-header-background-color: $beige-lighter;

//controls look and feel
$input-shadow: none;
$control-border-width: 2px;
//$input-background-color: $beige-lighter;
//$input-border-color: transparent;
$family-primary: $family-sans-serif;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
